const slideDown = () =>{
    const slideDownBlock = document.querySelector('[data-block="slide-down"]');

    try {
        slideDownBlock.addEventListener('click', (e)=>{
            let target = e.target;

            if(target.classList.contains('slide-down-title') || target.closest('.slide-down-title')) {
                let slideDownWrap = target.closest('.slide-down-wrap'),
                    slideDownContent = slideDownWrap.querySelector('.slide-down-content');
                
                if(slideDownWrap.classList.contains('active')) {
                    slideDownWrap.classList.remove('active');
                    slideDownContent.style.height = '0px';
                } else {
                    slideDownWrap.classList.add('active');
                    slideDownContent.style.height = slideDownContent.scrollHeight + 'px';
                }
            }
        });
    } catch(e){};
};
export default slideDown;